// extracted by mini-css-extract-plugin
export default {"launcher":"R_fX","launcher__heading":"R_fY","launcher__menu-item":"R_fZ"};